<template>
   <div id="setting">
       <div class="mcontainer">
           <div class="flex justify-between relative md:mb-4 mb-3">
               <div class="flex-1">
                   <h2 class="text-lg font-semibold">Setting</h2>
                   <p>Ubah hal-hal terkait akun anda</p>
               </div>
           </div>
           <div class="relative">
               <div class="px-1 py-3">
                   <b-tabs content-class="mt-4">
                       <b-tab title="Profile" active>
                           <div class="card profile-card">
                               <div class="col-md-12 content-form">
                                   <div class="profile-photo-section">
                                       <div class="photo-upload-wrapper" @click="$refs.images.click()" title="Klik untuk mengubah foto profil">
                                           <Avatar :src="previewImage" :name="datauser.fullname" size="xl" />
                                           <div class="photo-upload-overlay">
                                               <Icon icon="bi:camera-fill" class="camera-icon" />
                                               <span>Ganti Foto</span>
                                           </div>
                                       </div>
                                       <input type="file" ref="images" accept="image/*" @change="onFileSelected" style="display:none">
                                       <p class="photo-hint">Klik foto untuk mengubah foto profil</p>
                                       <span v-if="selectedFile" class="photo-selected-badge">
                                           <Icon icon="bi:check-circle-fill" /> {{ selectedFile.name }}
                                       </span>
                                   </div>

                                   <form @submit.prevent="submitUser" class="profile-form">
                                       <div class="form-row">
                                           <div class="form-group col-md-6">
                                               <label>Nama Lengkap</label>
                                               <input type="text" v-model="datauser.fullname" class="form-control" placeholder="Nama Lengkap">
                                           </div>
                                           <div class="form-group col-md-6">
                                               <label>NRP</label>
                                               <input type="text" v-model="datauser.no_induk" class="form-control" placeholder="Nomor NRP">
                                           </div>
                                           <div class="form-group col-md-6">
                                               <label>Fakultas</label>
                                               <input type="text" v-model="datauser.faculity" class="form-control" placeholder="Fakultas">
                                           </div>
                                           <div class="form-group col-md-6">
                                               <label>Angkatan</label>
                                               <input type="text" v-model="datauser.generation" class="form-control" placeholder="Angkatan">
                                           </div>
                                           <div class="form-group col-md-6">
                                               <label>Tempat, Tanggal Lahir</label>
                                               <input type="text" v-model="datauser.ttl" class="form-control" placeholder="cth: Surabaya, 01 Januari 2000">
                                           </div>
                                           <div class="form-group col-md-6">
                                               <label>Email</label>
                                               <input type="email" v-model="datauser.email" class="form-control" placeholder="Email">
                                           </div>
                                          <div class="form-group col-md-6">
                                              <label>No. Telepon</label>
                                              <input type="text" v-model="datauser.phone" class="form-control" placeholder="No. Telepon">
                                          </div>
                                          <div class="form-group col-md-6">
                                              <label>Pekerjaan / Usaha</label>
                                              <input type="text" v-model="datauser.pekerjaan" class="form-control" placeholder="Pekerjaan / Usaha saat ini">
                                          </div>
                                          <div class="form-group col-md-6">
                                              <label>Username Instagram</label>
                                               <div class="input-group">
                                                   <div class="input-group-prepend">
                                                       <span class="input-group-text">@</span>
                                                   </div>
                                                   <input type="text" v-model="datauser.ig_username" class="form-control" placeholder="username">
                                               </div>
                                           </div>
                                           <div class="form-group col-md-12">
                                               <label>Alamat</label>
                                               <input type="text" v-model="datauser.address" class="form-control" placeholder="Alamat">
                                           </div>
                                           <div class="form-group col-md-12">
                                               <label>Tentang Anda</label>
                                               <textarea class="form-control" v-model="datauser.about" rows="4" placeholder="Ceritakan sedikit tentang diri Anda..."></textarea>
                                           </div>
                                       </div>
                                       <div class="form-action">
                                           <button class="btn btn-primary" type="submit" :disabled="saving">
                                               <span v-if="saving"><Icon icon="bi:arrow-repeat" class="spin-icon" />&nbsp;Menyimpan...</span>
                                               <span v-else>Simpan Perubahan</span>
                                           </button>
                                       </div>
                                   </form>
                               </div>
                           </div>
                       </b-tab>
                        <b-tab title="Account Setting">
                            <div class="card">
                                <div class="col-md-12 content-form">
                                    <h3 class="title-bold">Pengaturan Privasi Data</h3><br>
                                    <div class="row">
                                        <div class="col-md-5 mb-3">
                                            <strong>Tempat Tanggal Lahir</strong><br>
                                            <p>Menampilkan Taggal Lahir anda</p>
                                        </div>
                                        <div class="col-md-7 mb-3">
                                            <div class="switches-list is-large">
                                                <div class="switch-container">
                                                    <label class="switch"><input type="checkbox" v-model="datauser.show_ttl" checked=""><span class="switch-button"></span> </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-5 mb-3">
                                            <strong>Nomor NRP</strong><br>
                                            <p>Menampilkan Nomor NRP pada akun</p>
                                        </div>
                                        <div class="col-md-7 mb-3">
                                            <div class="switches-list is-large">
                                                <div class="switch-container">
                                                    <label class="switch"><input type="checkbox" v-model="datauser.show_nrp" checked=""><span class="switch-button"></span> </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br>
                                    <h3 class="title-bold">Pengaturan Akun</h3><br>
                                    <div class="row">
                                        <div class="col-md-5 mb-3">
                                            <strong>Instagram</strong><br>
                                            <p>Menampilkan username instagram</p>
                                        </div>
                                        <div class="col-md-7 mb-3">
                                            <div class="switches-list is-large">
                                                <div class="switch-container">
                                                    <label class="switch"><input type="checkbox" v-model="datauser.show_ig"><span class="switch-button"></span> </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-5 mb-3">
                                            <strong>No telepon</strong><br>
                                            <p>Menampilkan Nomor telepon anda</p>
                                        </div>
                                        <div class="col-md-7 mb-3">
                                            <div class="switches-list is-large">
                                                <div class="switch-container">
                                                    <label class="switch"><input type="checkbox" v-model="datauser.show_telp" checked=""><span class="switch-button"></span> </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button class="btn btn-primary" type="button" @click="submitUser">Simpan</button>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab title="Privacy Policy">
                            <div class="card">
                                <div class="col-md-9 content-form description">
                                    <h3 class="title-bold">Introduction</h3>
                                    <p>Sed non dui aliquam, ullamcorper est non, aliquet mauris. Quisque lacus ligula, dapibus nec dignissim non, tincidunt vel quam. Etiam porttitor iaculis odio.</p>
                                    <p>Cras sagittis nunc lectus, in condimentum ligula ornare at. Etiam sagittis malesuada nisl. Duis volutpat ligula ante. Sed cursus, tortor a pellentesque pulvinar, lorem ipsum gravida elit, id posuere elit neque in est. Mauris ex justo, tincidunt at suscipit quis, pretium a mi.</p>
                                </div>
                            </div>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState, mapActions } from 'vuex'
    import { Icon } from '@iconify/vue2'

    export default {
        name: 'Setting',
        computed: mapState('auth', { datauser: 'user' }),
        components: {
            Icon
        },
        data () {
            return {
                previewImage: '',
                selectedFile: null,
                saving: false
            }
        },
        created () {
            this.previewImage = this.datauser.images || ''
        },
        methods: {
            ...mapActions('auth', ['update', 'getUser']),
            onFileSelected (e) {
                const file = e.target.files[0]
                if (!file) return
                if (!file.type.startsWith('image/')) {
                    this.$swal({ icon: 'error', title: 'Format tidak valid', text: 'Hanya file gambar yang diperbolehkan.' })
                    return
                }
                this.selectedFile = file
                this.previewImage = URL.createObjectURL(file)
                e.target.value = ''
            },
            submitUser () {
                const { fullname, faculity, generation, ttl, email, phone, address, about, pekerjaan } = this.datauser
                const payload = {
                    fullname,
                    no_induk: this.datauser.no_induk,
                    faculity,
                    generation,
                    ttl,
                    email,
                    phone,
                    pekerjaan,
                    ig_username: this.datauser.ig_username,
                    address,
                    about,
                    show_ttl: this.datauser.show_ttl,
                    show_telp: this.datauser.show_telp,
                    show_nrp: this.datauser.show_nrp,
                    show_ig: this.datauser.show_ig
                }
                if (this.selectedFile) {
                    payload.images = this.selectedFile
                }
                this.saving = true
                this.update({ data: payload })
                    .then(() => {
                        this.selectedFile = null
                        return this.getUser()
                    })
                    .then(() => {
                        this.previewImage = this.datauser.images || ''
                        this.$swal({
                            imageUrl: require('@/assets/images/vector-success.png'),
                            imageWidth: 400,
                            title: 'Berhasil Update',
                            text: 'Informasi data diri anda berhasil disimpan.'
                        })
                    })
                    .catch(() => {
                        this.$swal({ icon: 'error', title: 'Gagal', text: 'Terjadi kesalahan saat menyimpan data.' })
                    })
                    .finally(() => {
                        this.saving = false
                    })
            }
        }
    }
</script>

<style scoped>
.profile-card {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    overflow: hidden;
}

.profile-photo-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 24px 0 28px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 24px;
}

.photo-upload-wrapper {
    position: relative;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    cursor: pointer;
    border: 3px solid #e2e8f0;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
    transition: border-color 0.2s;
    overflow: hidden;
}

.photo-upload-wrapper:hover {
    border-color: #4a90d9;
}

.photo-upload-overlay {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    opacity: 0;
    transition: opacity 0.2s;
    color: #fff;
    font-size: 0.75rem;
    font-weight: 600;
}

.photo-upload-wrapper:hover .photo-upload-overlay {
    opacity: 1;
}

.camera-icon {
    font-size: 1.5rem;
}

.photo-hint {
    font-size: 0.78rem;
    color: #94a3b8;
    margin: 0;
}

.photo-selected-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: #ecfdf5;
    color: #059669;
    font-size: 0.78rem;
    font-weight: 500;
    padding: 4px 12px;
    border-radius: 20px;
    border: 1px solid #6ee7b7;
    max-width: 260px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.profile-form .form-group {
    margin-bottom: 16px;
}

.profile-form label {
    font-size: 0.82rem;
    font-weight: 600;
    color: #475569;
    margin-bottom: 4px;
    display: block;
}

.profile-form .form-control {
    font-size: 0.9rem;
}

.form-action {
    padding-top: 8px;
    display: flex;
    justify-content: flex-end;
}

.spin-icon {
    display: inline-block;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}
</style>
